import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function DatabaseReplication() {
    return (
        <TopicLayout
            title="Synchronous vs. asynchronous database replication"
            intro="Whether the primary waits for replicas to acknowledge a write before telling the client it committed, or confirms the write immediately and lets replicas catch up afterward."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={140} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Synchronous</text>
                    <Box x={100} y={25} width={80} height={32} label="Primary" accent/>
                    <Box x={20} y={90} width={90} height={32} label="Replica 1"/>
                    <Box x={150} y={90} width={90} height={32} label="Replica 2"/>
                    <Arrow x1={115} y1={57} x2={65} y2={90}/>
                    <Arrow x1={165} y1={57} x2={195} y2={90}/>
                    <text x={140} y={140} textAnchor="middle" fontSize={11} opacity={0.7}>commit waits for both acks</text>

                    <line x1={280} y1={10} x2={280} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={420} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Asynchronous</text>
                    <Box x={380} y={25} width={80} height={32} label="Primary" accent/>
                    <Box x={300} y={90} width={90} height={32} label="Replica 1"/>
                    <Box x={430} y={90} width={90} height={32} label="Replica 2"/>
                    <Arrow x1={395} y1={57} x2={345} y2={90} dashed muted/>
                    <Arrow x1={445} y1={57} x2={475} y2={90} dashed muted/>
                    <text x={420} y={140} textAnchor="middle" fontSize={11} opacity={0.7}>commits immediately, replicates after</text>
                </Diagram>
            }
            useWhen={[
                'Synchronous: the required durability policy must include confirmation from configured replicas before acknowledging a write.',
                'Asynchronous: lower write latency and some replication lag or recent-write loss during failover are acceptable.'
            ]}
            tradeOff="Waiting for replicas increases write latency and can reduce write availability when replicas are unreachable. Asynchronous replicas keep writes responsive but may serve stale reads and can lose acknowledged transactions during failover. Synchronous replication does not automatically mean zero data loss: guarantees depend on which replicas must acknowledge, persistence settings and correct failover selection."
            ruleOfThumb="Choose acknowledgement and failover policies from the recovery point objective, then test failover; use synchronous acknowledgement only where its durability benefit is worth the latency and availability cost."
        />
    )
}
